import React, { Component, Fragment } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";

import { adminRoute } from "../../../config/roles";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import images from "../../../utils/images";
import { List, ListItem, ListTitleBar, TitleBarItem } from "../../UI/ListView";
import SearchBar from "../../UI/SearchBar";
import { toTitleCase } from "../../../utils/filters";

const PROVIDER_LIST_CONF = [
  { colValue: "col-2", listTitleText: "Name" },
  { colValue: "col-2", listTitleText: "Email Address" },
  { colValue: "col-2", listTitleText: "Provider Types" },
  { colValue: "col-1", listTitleText: "Referral Count" },
  { colValue: "col-1", listTitleText: "Working Hours" },
  { colValue: "col-1", listTitleText: "Total Patients" },
  { colValue: "col-1", listTitleText: "Profile" },
  { colValue: "col-1", listTitleText: "Schedule" },
  { colValue: "col-1", listTitleText: "" },
];

export default class ProviderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      providerList: props.providerList,
      search: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.providerList !== this.state.providerList) {
      this.setState({
        providerList: this.props.providerList,
      });
    }
  }

  updateSearch = (e) => {
    this.setState({ search: e.target.value });
  };

  addButtonClickHandler = () => {
    this.props.history.push(`${this.props.match.url}/provider/add`);
  };

  getFilteredProviders = (list) => {
    return list.filter((provider) => {
      return provider.name.toLowerCase().match(new RegExp("^" + this.state.search.toLowerCase()));
    });
  };

  setProviderDetails = (providerId) => {
    this.props.history.push(`${this.props.match.url}/provider/${providerId}`);
  };

  viewProviderSchedule = (providerId) => {
    this.props.history.push(`${adminRoute}/schedule/${providerId}/view?view=list`);
  };

  viewProviderProfile = (providerId) => {
    this.props.history.push(`${adminRoute}/profile/${providerId}`);
  };

  render() {
    return (
      <DashboardCard2
        Actions={
          <div className="tw:flex tw:gap-2">
            <SearchBar className="mr-lg-2" onchange={this.updateSearch} value={this.state.search} />
            <Button2 onPress={this.addButtonClickHandler} size="sm">
              New Provider
            </Button2>
          </div>
        }
        data-public="true"
        isFullBleed
        title="Providers"
        {...getAutomationDataAttr("PracticePage_Providers")}
      >
        <ListTitleBar>
          {PROVIDER_LIST_CONF.map((titleConf) => {
            return (
              <TitleBarItem
                classes={titleConf.colValue}
                key={titleConf.listTitleText.trim()}
                text={titleConf.listTitleText}
              />
            );
          })}
        </ListTitleBar>

        <List>
          <Fragment>
            {this.getFilteredProviders(this.state.providerList).map((provider, i) => {
              return (
                <ListItem
                  clickHandler={() => this.setProviderDetails(provider.username)}
                  clickOnMobile
                  key={provider.username}
                >
                  <ProviderListItem
                    provider={provider}
                    setProviderDetails={this.setProviderDetails}
                    viewProviderProfile={this.viewProviderProfile}
                    viewProviderSchedule={this.viewProviderSchedule}
                  />
                </ListItem>
              );
            })}
          </Fragment>
        </List>
      </DashboardCard2>
    );
  }
}

const ProviderListItem = (props) => {
  const { provider, setProviderDetails, viewProviderProfile, viewProviderSchedule } = props;
  const groupTypesWithSchedules = ["PRESCRIBE", "BEHAVIORAL", "BEHAVIORAL_INTAKE"];
  const groupTypesWithProfilesToUpdate = groupTypesWithSchedules + ["PEER", "CASE_MANAGER"];
  const totalPatients = provider.total_patients || 0;

  let desktopListItem = (
    <div className="row no-gutters d-none d-lg-flex fs-14 align-items-center justify-content-between">
      <span className="col-2">{toTitleCase(provider.name)}</span>
      <span
        className="col-2"
        data-placement="top"
        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
        title={provider.email}
        {...getAutomationDataAttr("ProviderList_email")}
      >
        {provider.email}
      </span>
      <span className="col-2">{provider.provider_type}</span>
      <span className="col-1">{provider.referral_count}</span>
      <span className="col-1">{provider.number_of_weekly_working_hours}</span>
      <span className="col-1">{totalPatients}</span>
      <span className="col-1">
        {groupTypesWithProfilesToUpdate.includes(provider.provider_type) && (
          <div className="cursor">
            <img
              alt="view icon"
              onClick={() => viewProviderProfile(provider.username)}
              src={images("./common/profile_icon.svg")}
            />
          </div>
        )}
      </span>
      <span className="col-1">
        {groupTypesWithSchedules.includes(provider.provider_type) && (
          <div className="cursor">
            <img
              alt="view icon"
              onClick={() => viewProviderSchedule(provider.username)}
              src={images("./icons/calender-icon.svg")}
            />
          </div>
        )}
      </span>
      <div className="col-1">
        <div className="cursor ml-2">
          <img
            alt="view icon"
            onClick={() => setProviderDetails(provider.username)}
            src={images("./common/view.png")}
          />
        </div>
      </div>
    </div>
  );

  let mobileListItem = (
    <div className="d-flex d-lg-none justify-content-between">
      <div className="d-flex fs-14 flex-column" style={{ width: "65%", wordWrap: "break-word" }}>
        <span className="fs-16 tw:font-bold">{toTitleCase(provider.name)}</span>
        <span>{provider.email}</span>
      </div>
      <div className="d-flex fs-14 flex-column">
        <div>
          <span>{provider.provider_type}</span>
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      {mobileListItem}
      {desktopListItem}
    </Fragment>
  );
};
